import { render } from "./eVisaPending.vue?vue&type=template&id=51c10d4a&scoped=true"
import script from "./eVisaPending.vue?vue&type=script&lang=js"
export * from "./eVisaPending.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=51c10d4a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c10d4a"]])

export default __exports__